export default "__VITE_ASSET__16b1e6d6__"